import React from 'react';
import PropTypes from 'prop-types';
import planImpactFormatter from './PlanImpactRowFormatter';

const PlanImpactRowView = ({
  label, current, proposed, isLoading, loadingComponent,
}) => (
  <tr>
    <td className="label">
      {isLoading && loadingComponent}
      {label}
    </td>
    <td className="current">{planImpactFormatter(current)}</td>
    <td className="proposed">{planImpactFormatter(proposed)}</td>
  </tr>
);

PlanImpactRowView.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  loadingComponent: PropTypes.element.isRequired,
  label: PropTypes.string.isRequired,
  current: PropTypes.string.isRequired,
  proposed: PropTypes.string.isRequired,
};

export default PlanImpactRowView;
